import { useEffect, useState } from 'react'
import { loadEventPositions, type EventPositionData } from '../utils/eventPositions'

/** Posiciones de monstruos dentro de eventos; se cargan una vez y se comparten entre fichas. */
export function useEventPositions(): EventPositionData | undefined {
  const [data, setData] = useState<EventPositionData | undefined>()
  useEffect(() => {
    let alive = true
    loadEventPositions().then((d) => alive && setData(d))
    return () => {
      alive = false
    }
  }, [])
  return data
}
